import { Component, Input } from '@angular/core';


@Component({
    selector: 'sgt-cliente-segmento-card-chart',
    templateUrl: './cliente-segmento-card-chart.component.html',
    styleUrls: ['./cliente-segmento-card-chart.component.less']
})
export class ClienteSegmentoCardChartComponent {
    @Input() nome: string;
    @Input() quantidadeClientes: number;
    @Input() percParticipacao: number;
}
